import { Stack } from "@mui/material";
import { type PaymentsListItem } from "@src/appV2/redesign/Payments/Earnings/types/PaymentsListItem";
import { CbhIcon, ListItem, ListItemText, Text } from "@src/appV2/redesign/system/ui-components";

import { PaymentHistoryItem } from "./PaymentHistoryItem";

interface PaymentHistorySectionProps {
  payments: PaymentsListItem[];
}

export function PaymentHistorySection(props: PaymentHistorySectionProps) {
  const { payments } = props;

  const sortedPayments = payments.toSorted(
    (a, b) =>
      new Date(b.attributes.createdAt).getTime() - new Date(a.attributes.createdAt).getTime()
  );

  return (
    <ListItem divider={true}>
      <ListItemText
        disableTypography
        primary={
          <Stack direction="row" gap={3} width="100%">
            <Stack flexShrink={0}>
              <CbhIcon type="coin-filled" />
            </Stack>
            <Stack flex={1} minWidth={0}>
              <Text
                semibold
                variant="h6"
                sx={(theme) => ({
                  color: theme.palette.text.primary,
                })}
                mb={2}
              >
                Earnings
              </Text>
              <Stack spacing={0}>
                {sortedPayments.map((payment) => (
                  <PaymentHistoryItem key={payment.id} item={payment} />
                ))}
              </Stack>
            </Stack>
          </Stack>
        }
      />
    </ListItem>
  );
}
